import Button, {ButtonVariant} from "@components/Button";
import moment from "moment-timezone";
import React, {memo} from "react";

type SlotProps = {
  onClick: () => unknown;
  selected: boolean;
  time: number;
  timezone: string;
  disabled?: boolean;
};
const Slot = ({onClick, selected, time, timezone, disabled}: SlotProps) => {
  const locationTime = moment(time).tz(timezone);

  return (
    <Button
      key={time}
      variant={selected ? ButtonVariant.SELECTED_FILL : ButtonVariant.GHOST}
      size="sm"
      className="px-4 py-[0.8rem] flex items-center justify-center gap-2.5 font-semibold"
      onClick={onClick}
      data-cy="web-schedule-slot-time"
      disabled={disabled}
    >
      <span className="text-sm">{locationTime.format("h:mm a")}</span>
      <span className="text-gray400 text-xs font-i font-normal">{locationTime.format("z")}</span>
    </Button>
  );
};

export default memo(Slot);
